import { noop, queryOptions, useQuery } from "@tanstack/react-query";
import * as TypeCompiler from "typebox/compile";
import { ReadonlyArray } from "@/shared/schema/schema.ts";
import { CountryWithUserCounts } from "@/shared/schema/shared.ts";
import { httpChecked, queryClient } from "@/shared/util/fetch.tsx";

const countriesChecker = TypeCompiler.Compile(
  ReadonlyArray(CountryWithUserCounts),
);

const queries = {
  all: queryOptions({
    queryKey: ["countries", "all"] as const,
    queryFn: ({ signal }) =>
      httpChecked.get("/api/v1/countries/", countriesChecker, { signal }),
  }),
  allowed: queryOptions({
    queryKey: ["countries", "allowed"] as const,
    queryFn: ({ signal }) =>
      httpChecked.get(
        "/api/v1/countries/?only_allowed=true",
        countriesChecker,
        { signal },
      ),
  }),
};

export async function prefetchAllCountries() {
  // eslint-disable-next-line unicorn/prefer-await
  await queryClient.query({ ...queries.all, staleTime: 60_000 }).catch(noop);
}

export function useAllCountries() {
  return useQuery({ ...queries.all, staleTime: 60_000 });
}
